import { Grid } from '@mui/material';
import { ResponsiveButton, Svg } from 'components';
import { MoreAdvisorsCTAContainer } from './styled';

export default function MoreAdvisors() {
  return (
    <MoreAdvisorsCTAContainer>
      <Grid container spacing={6.5}>
        <Grid item xs={2} sm={2} md={3} />
        <Grid item xs={8} sm={4} md={3}>
          <ResponsiveButton
            className="see-more-advisors"
            sx={{ m: 2, width: '255px' }}
            variant="outlined"
            size="comfy"
            href="/psychic-readings/195">
            See More Advisors
          </ResponsiveButton>
        </Grid>
        <Grid item xs={2} display={{ sm: 'none' }} />
        <Grid item xs={2} display={{ sm: 'none' }} />
        <Grid item xs={8} sm={4} md={3}>
          <ResponsiveButton
            className="get-matched"
            sx={{ my: 1, mx: 2, width: '255px' }}
            variant="outlined"
            size="comfy"
            href="/app/best-match?q=0">
            Get Matched
          </ResponsiveButton>
        </Grid>
        <Grid item xs={2} display={{ sm: 'none' }} />
        <Grid
          className="try-best-match"
          item
          sm={2}
          md={3}
          sx={{
            display: {
              xs: 'none',
              sm: 'inline-block',
              md: 'inline-block'
            }
          }}>
          <Svg name="tryBestMatch" height="40px" />
        </Grid>
      </Grid>
    </MoreAdvisorsCTAContainer>
  );
}
